"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIGURATIONS_TYPES = exports.CONFIGURATIONS_GROUPS = void 0;
var CONFIGURATIONS_TYPES = exports.CONFIGURATIONS_TYPES = ['INT', 'DECIMAL', 'BOOLEAN', 'STRING'];
var CONFIGURATIONS_GROUPS = exports.CONFIGURATIONS_GROUPS = ['GENERAL', 'ADVANCES', 'FILES', 'AUTHORIZATIONS', 'PAYABLE_DOCUMENTS', 'RECONCILIATIONS', 'ACCOUNTING', 'DASHBOARD', 'CUSTOM_DEVELOPMENT', 'REFUNDS', 'MENU', 'MOBILE', 'NOTIFICATIONS', 'JOURNAL_ENTRIES', 'EXPENSES', 'BALANCES_PAYMENTS', 'SECURITY', 'SUPPORT', 'EXCHANGE_RATE', 'VALIDATIONS', 'INTEGRATONS'];